import { ChangeRequestCommentType } from './changerequestcommenttype.enum';

export class ChangeRequestComment {
  type: ChangeRequestCommentType;
  text: string;

  constructor(comment: IChangeRequestComment) {
    this.type = comment.type;
    this.text = comment.text;
  }
}

export interface IChangeRequestComment {
  type: ChangeRequestCommentType;
  text: string;
}
